import Chart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { getDateForChart } from 'src/feature/bite/helpers/date'
import Spinner from 'react-bootstrap/esm/Spinner'

export default function LineChart({
  data: { series, categories },
}: {
  data: {
    series: { name: string; data: number[] }[]
    categories: string[]
  }
}) {
  const options: ApexOptions = {
    chart: {
      type: 'line',
      zoom: {
        enabled: false,
      },
    },
    // toolbar: {
    //   show: true,
    //   tools: {
    //     download: false,
    //   },
    // },
    // export: {
    //   enabled: false,
    // },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
      colors: ['#5b0b93'],
    },
    grid: {
      show: false,
      padding: {
        left: 30,
        right: 50,
        bottom: 10,
        top: 10,
      },
    },
    xaxis: {
      // type: 'datetime',
      type: 'category',
      tickPlacement: 'between',
      tickAmount: 'dataPoints',
      labels: {
        formatter: (value: string) => {
          return getDateForChart(value)
        },
        // offsetY: 5,
      },
      tooltip: {
        enabled: false,
      },
      categories,
    },
    yaxis: {
      show: false,
    },
  }

  if (series[0].data.length === 0) {
    return <div style={{ height: 300, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Spinner animation='border' /></div>
  }

  return <><Chart options={options} series={series} type='line' height={350} /></>
}
